import http from "../../services/http";

const getCurriculoUsuario = async () => {
  return await http("get", `v1/curriculo_usuarios/carregar`, []);
};

const changeCurriculoUsuario = async (formData) => {
  return await http("post", "v1/curriculo_usuarios/alterar", formData);
};

const changeSenha = async (formData) => {
  return await http("post", "v1/curriculo_usuarios/alterar_senha", formData);
};

const deleteCurriculo = async (formData) => {
  return await http("post", "v1/curriculo_usuarios/deletar", formData);
};

export { getCurriculoUsuario, changeCurriculoUsuario, changeSenha, deleteCurriculo };
